import { Controller } from "@hotwired/stimulus"

// File picking for the import & export page. Attached to the upload <form>.
// Two flavors: source-card quick actions (hidden input, submits as soon as a
// file is picked) and the guide dropzone (drag & drop, filename display,
// submit button enabled once a file is chosen).
export default class extends Controller {
    static targets = ["input", "zone", "name", "submit"]
    static values = { autosubmit: Boolean }

    pick(event) {
        event.preventDefault()
        this.inputTarget.click()
    }

    changed() {
        this.fileChosen()
    }

    dragover(event) {
        event.preventDefault()
        this.zoneTarget.classList.add("is-dragover")
    }

    dragleave(event) {
        event.preventDefault()
        this.zoneTarget.classList.remove("is-dragover")
    }

    drop(event) {
        event.preventDefault()
        this.zoneTarget.classList.remove("is-dragover")
        let files = event.dataTransfer && event.dataTransfer.files
        if (!files || files.length === 0) return
        this.inputTarget.files = files
        this.fileChosen()
    }

    fileChosen() {
        let file = this.inputTarget.files[0]
        if (!file) return
        if (this.autosubmitValue) {
            if (this.element.requestSubmit) {
                this.element.requestSubmit()
            } else {
                this.element.submit()
            }
            return
        }
        if (this.hasNameTarget) {
            this.nameTarget.textContent = file.name
            this.nameTarget.classList.add("is-set")
        }
        if (this.hasSubmitTarget) this.submitTarget.disabled = false
    }
}
